import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function MailingListSignup() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/mailing-list/subscribe`, null, {
        params: { email, name: name || undefined }
      });
      toast.success(response.data.message);
      setEmail('');
      setName('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to subscribe');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-[#2C1810] via-[#E85D4D]/30 to-[#2C1810]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="cassette-card p-8 md:p-12 text-center">
          <div className="inline-flex p-4 rounded-full bg-[#E8934D] mb-6">
            <Mail className="w-8 h-8 text-white" />
          </div>
          
          <h2 className="text-4xl md:text-5xl retro-title mb-4">
            Join Our Mailing List
          </h2>
          <p className="text-xl text-[#6B4423] mb-8">
            Stay updated with the latest insights on acupuncture, TCM, and wellness
          </p>

          <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-4">
            <input
              type="text"
              placeholder="Your Name (optional)"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border-2 border-[#6B4423] focus:border-[#E8934D] outline-none"
            />
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-lg border-2 border-[#6B4423] focus:border-[#E8934D] outline-none"
            />
            <button
              type="submit"
              disabled={loading}
              className="retro-button w-full text-lg py-3"
            >
              {loading ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>

          <p className="text-sm text-[#6B4423] mt-6">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>
  );
}
